<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow v-if="chargeId !== null" :confirm="askConfirm"
                    :title="$t('Modify') + ' ' + $t('l.e') + ' ' + $t('chargePro')"
                    route-back="ProfessionalChargesIndex"/>
        <back-arrow v-else :confirm="askConfirm" :title="$t('New.e') + ' ' + $t('chargePro')"
                    route-back="ProfessionalChargesIndex"/>
      </div>

      <b-card class="col-md-12 my-3">
        <b-form v-unsave-detector @submit.stop.prevent="onSubmit">

          <div class="row">
            <div class="col-md-6">
              <b-form-group
                :invalid-feedback="form.name.invalidFeedback"
                :label="$t('chargePro.Name')"
                :state="form.name.state"
                class="medium-label mb-4"
                label-for="name-input">
                <b-form-input
                  id="name-input"
                  v-model="form.name.value"
                  :state="form.name.state"
                  maxlength="250"
                  required
                  type="text"
                  v-on:change="askConfirm=true;">
                </b-form-input>
              </b-form-group>
            </div>

            <div class="col-md-6">
              <AutocompleteField
                :input-class="'medium-label mb-4'"
                :input-id="'type-input'"
                :input-label="$t('chargePro.Type.label')"
                :items="types"
                :placeholder="$t('chargePro.Type.placeholder')"
                :required="true"
                :search-input="form.type.value"
                @elementValueChanged="getSelectedValue">
              </AutocompleteField>
            </div>

            <div v-if="chargeId == null || !isChargeGroup" class="col-md-6">
              <b-form-group
                :label="$t('chargePro.Date.label')"
                class="medium-label mb-4"
                label-for="date-charge-input">
                <datepicker-input
                  id="date-charge-input"
                  v-model="form.date.value"
                  :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                  :label-reset-button="$t('Delete')"
                  :placeholder="''"
                  :reset-button="true">
                </datepicker-input>
              </b-form-group>
            </div>

            <div v-if="chargeId == null" class="col-md-6">
              <b-form-group
                :invalid-feedback="form.duree.invalidFeedback"
                :label="$t('chargePro.Duree.label')"
                :state="form.duree.state"
                class="medium-label mb-4"
                label-for="duree-input">
                <b-form-input
                  id="duree-input"
                  v-model="form.duree.value"
                  v-disable-scroll
                  :state="form.duree.state"
                  max="24"
                  min="1"
                  required
                  step="1"
                  type="number">
                </b-form-input>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <b-form-group
                :invalid-feedback="form.value.invalidFeedback"
                :label="$t('chargePro.Value.label', {mensuel: form.duree.value>1?'mensuel':''})"
                :state="form.value.state"
                class="medium-label mb-4"
                label-for="value-input">
                <b-form-input
                  id="value-input"
                  v-model="form.value.value"
                  v-disable-scroll
                  :state="form.value.state"
                  no-wheel
                  required
                  type="number"
                  step="any"
                  v-on:change="askConfirm=true;">
                </b-form-input>
              </b-form-group>
            </div>

            <div class="col-md-4">
              <b-form-group
                :invalid-feedback="form.tva.invalidFeedback"
                :label="$t('chargePro.TVA.label')"
                :state="form.tva.state"
                class="medium-label mb-4"
                label-for="tva-input">
                <b-form-select
                  id="tva-input"
                  v-model="form.tva.value"
                  :state="form.tva.state"
                  required
                  v-on:change="askConfirm=true;">
                  <option v-for="tauxTVA in typesTVA" :value="tauxTVA.value">
                    {{ $t(tauxTVA.text) }}
                  </option>
                </b-form-select>
              </b-form-group>
            </div>

            <div class="col-md-4">
              <b-form-group
                :label="$t('chargePro.ValueHT.label', {mensuel: form.duree.value>1?'mensuel':''})"
                class="medium-label mb-4"
                label-for="value-ht-input">
                <b-form-input
                  id="value-ht-input"
                  v-model="valueht"
                  disabled>
                </b-form-input>
              </b-form-group>
            </div>
          </div>

          <div v-if="chargeId !== null" class="d-flex justify-content-end">
            <b-button type="submit" variant="primary">{{ $t('Validate') }}</b-button>
          </div>

          <div v-else class="d-flex justify-content-end">
            <b-button type="submit" variant="primary">{{ $t('Create') }}</b-button>
          </div>
        </b-form>
      </b-card>
    </b-container>

  </div>
</template>

<script>

import backArrow from "../../components/b122/BackArrow";
import AutocompleteField from "../../components/b122/editFields/AutocompleteField";
import api from "../../services/api";

export default {
  name: "ProfessionalChargesCreateEdit",



  components: {
    backArrow,
    AutocompleteField
  },

  data() {
    return {
      chargeId: this.$route.params.chargeId,
      isChargeSimple: this.$route.params.isChargeSimple,
      isChargeGroup: this.$route.params.isChargeGroup,
      chargeGroupId: this.$route.params.chargeGroupId,
      types: [],
      askConfirm: false,
      form: {
        name:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        type:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        value:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        tva:
          {
            state: null,
            invalidFeedback: null,
            value: 0.2
          },
        duree:
          {
            state: null,
            invalidFeedback: null,
            value: 1,
          },
        date:
          {
            state: null,
            invalidFeedback: null,
            value: null
          }
      },
      valueht: null,
      typesTVA: [],
      defaultMonth: null,
      defaultYear: null
    }
  },

  watch: {
    'form.value.value': function () {
      if (this.form.tva.value) {
        this.valueht = (Number(this.form.value.value) / (1 + Number(this.form.tva.value))).toFixed(2)
      } else {
        this.valueht = 0
      }
    },

    'form.tva.value': function () {
      if (this.form.value.value) {
        this.valueht = (Number(this.form.value.value) / (1 + Number(this.form.tva.value))).toFixed(2)
      } else {
        this.valueht = 0
      }
    }
  },

  async mounted() {
    await this.fetchData()
  },

  methods: {

    async fetchData() {
      if (this.chargeId) {
        await this.fetchCharge()
      }
      await this.fetchChargeTypes()
      await this.fetchTVATypes()
    },

    async fetchCharge() {
      await api
        .get(`/chargePro/${this.chargeId}`)
        .then(response => {
          this.form.name.value = response.data.name

          this.form.type.value = response.data.type
          this.form.tva.value = response.data.tva
          this.form.date.value = (new Date(response.data.date).toLocaleDateString()).split("/").reverse().join("-")
          this.form.value.value = Number(response.data.value / 100)
        })
    },

    async fetchChargeTypes() {
      await api
        .get(`/chargePro/getChargeTypes`)
        .then(response => {
          this.types = response.data
        })
    },

    async fetchTVATypes() {
      await api
        .get(`/chargePro/getTVATypes`)
        .then(response => {
          this.typesTVA = response.data
        })
    },

    getSelectedValue(data) {
      this.form.type.value = data
    },

    async onSubmit() {
      let data = new FormData()
      data.append('name', this.form.name.value)
      data.append('type', this.form.type.value)
      data.append('value', this.form.value.value)
      data.append('tva', this.form.tva.value)
      data.append('duree', this.form.duree.value)
      data.append('date', this.form.date.value)

      let url = 'chargePro'
      if (this.chargeId) {
        url = '/chargePro/' + this.chargeId
        data.append('chargeGroupId', this.chargeGroupId)
      }

      await api({
        method: 'POST',
        url: url,
        data: data
      })
        .then(() => {
          this.$router.push({
            name: 'ProfessionalChargesIndex'
          }, () => {
            this.$nextTick(() => {
              this.successToast(this.form.name.value)
            })
          })
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'ProfessionalChargesIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    },

    successToast(chargeName) {
      this.$bvToast.toast(this.$i18n.t('ChargePro') + ' "' + chargeName + '" ' + this.$i18n.t('f.registered.object'), {
        autoHideDelay: 4000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: "success",
        solid: true,
      })
    }
  }
}
</script>

<style scoped>

.prixTTCContainer {
  padding: 8px 12px;
  background-color: #F4F4F4;
  color: #CCCCCC;
  border: solid 1px #CCCCCC;
}

.prixTTC {
  color: var(--main-color);
}
</style>



// WEBPACK FOOTER //
// src/views/professionalCharges/ProfessionalChargesCreateEdit.vue